import Vue from "vue";
import Router from "vue-router";
import store from "./store/store";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return {
      x: 0,
      y: 0,
    };
  },
  routes: [
    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: "",
      component: () => import("./layouts/main/Main.vue"),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: "/",
          redirect: "/login",
        },
        {
          path: "/dashboard",
          name: "Dashboard",
          component: () => import("./views/dashboard.vue"),
        },
        {
          path: "/users",
          name: "Users",
          component: () => import("./views/users/listing.vue"),
        },
        {
          path: "/users/add",
          name: "AddUser",
          component: () => import("./views/users/add-user.vue"),
        },
        {
          path: "/users/edit/:id",
          name: "EditUser",
          component: () => import("./views/users/edit-user.vue"),
        },
        {
          path: "/users/view/:id",
          name: "ViewUser",
          component: () => import("./views/users/view-user.vue"),
        },
        {
          path: "/change-password",
          name: "ChangePassword",
          component: () => import("./views/change-password.vue"),
        },
        {
          path: "/profile/edit",
          name: "EditProfile",
          component: () => import("./views/edit-profile.vue"),
        },
        {
          path: "/profile",
          name: "Profile",
          component: () => import("./views/profile.vue"),
        },
        {
          path: "/roles",
          name: "Roles",
          component: () => import("./views/role-management/listing.vue"),
        },
        {
          path: "/role/view/:id",
          name: "ViewRole",
          component: () => import("./views/role-management/view-role.vue"),
        },
        {
          path: "/role/add",
          name: "AddRole",
          component: () => import("./views/role-management/add-role.vue"),
        },
        {
          path: "/role/edit/:id",
          name: "EditRole",
          component: () => import("./views/role-management/edit-role.vue"),
        },
        {
          path: "/leads",
          name: "Leads",
          component: () => import("./views/leads/listing.vue"),
        },
        {
          path: "/leads/view/:id",
          name: "ViewLead",
          component: () => import("./views/leads/view-lead.vue"),
        },
        {
          path: "/lead/edit/:id",
          name: "EditLead",
          component: () => import("./views/leads/edit-lead.vue"),
        },
        {
          path: "/lead/add",
          name: "AddLead",
          component: () => import("./views/leads/add-lead.vue"),
        },
        {
          path: "/masters/countries",
          name: "Countries",
          component: () => import("./views/masters/countries/list.vue"),
        },
        {
          path: "/masters/country/add",
          name: "AddCountry",
          component: () => import("./views/masters/countries/add.vue"),
        },
        {
          path: "/masters/country/edit/:id",
          name: "EditCountry",
          component: () => import("./views/masters/countries/edit.vue"),
        },
        {
          path: "/masters/vessel-types",
          name: "VesselTypes",
          component: () => import("./views/masters/vessel-types/list.vue"),
        },
        {
          path: "/masters/vessel-type/add",
          name: "AddVesselType",
          component: () => import("./views/masters/vessel-types/add.vue"),
        },
        {
          path: "/masters/vessel-type/edit/:id",
          name: "EditVesselType",
          component: () => import("./views/masters/vessel-types/edit.vue"),
        },
        {
          path: "/masters/sections",
          name: "Sections",
          component: () =>
            import("./views/masters/section-subsection/list.vue"),
        },
        {
          path: "/masters/section/add",
          name: "AddSection",
          component: () => import("./views/masters/section-subsection/add.vue"),
        },
        {
          path: "/masters/section/edit/:id",
          name: "EditSection",
          component: () =>
            import("./views/masters/section-subsection/edit.vue"),
        },
        {
          path: "/masters/services",
          name: "Services",
          component: () => import("./views/masters/services/list.vue"),
        },
        {
          path: "/masters/service/add",
          name: "AddServices",
          component: () => import("./views/masters/services/add.vue"),
        },
        {
          path: "/masters/service/edit/:id",
          name: "EditServices",
          component: () => import("./views/masters/services/edit.vue"),
        },
        {
          path: '/organizations',
          name: 'OrganizationList',
          component: () => import('./views/organizations/list.vue')
        },
        {
          path: '/organizations/add',
          name: 'AddOrganization',
          component: () => import('./views/organizations/AddEditOrganization.vue')
        },
        {
          path: '/organizations/edit/:id',
          name: 'EditOrganization',
          component: () => import('./views/organizations/AddEditOrganization.vue')
        },
        {
          path: "/masters/designations",
          name: "Designation",
          component: () => import("./views/masters/designation/list.vue"),
        },
        {
          path: "/masters/designation/add",
          name: "AddDesignation",
          component: () => import("./views/masters/designation/add.vue"),
        },
        {
          path: "/masters/designation/edit/:id",
          name: "EditDesignation",
          component: () => import("./views/masters/designation/edit.vue"),
        },

        {
          path: "/masters/ports",
          name: "Ports",
          component: () => import("./views/masters/ports/list.vue"),
        },
        {
          path: "/masters/ports/add",
          name: "AddPort",
          component: () => import("./views/masters/ports/add.vue"),
        },
        {
          path: "/masters/ports/edit/:id",
          name: "EditPort",
          component: () => import("./views/masters/ports/edit.vue"),
        },

        {
          path: "/masters/defects",
          name: "Defects",
          component: () => import("./views/masters/defects/list.vue"),
        },
        {
          path: "/masters/defects/add",
          name: "AddDefect",
          component: () => import("./views/masters/defects/add.vue"),
        },
        {
          path: "/masters/defects/edit/:id",
          name: "EditDefect",
          component: () => import("./views/masters/defects/edit.vue"),
        },
        {
          path: "/masters/qualification-officers",
          name: "Officers",
          component: () =>
            import("./views/masters/qualification-officers/list.vue"),
        },
        {
          path: "/masters/qualification-officers/add",
          name: "AddOfficers",
          component: () =>
            import("./views/masters/qualification-officers/add.vue"),
        },
        {
          path: "/masters/qualification-officers/edit/:id",
          name: "EditOfficers",
          component: () =>
            import("./views/masters/qualification-officers/edit.vue"),
        },
        {
          path: "/masters/templates",
          name: "privilege",
          component: () => import("./views/masters/executive-summary/list.vue"),
        },
        {
          path: "/masters/folders",
          name: "folders",
          component: () => import("./views/masters/folders/listV2.vue"),
        },
        {
          path: "/masters/sections/:vessel_type_id/:vessel_sub_type_id",
          name: "ListSection",
          component: () => import("./views/masters/folders/list.vue"),
        },
        {
          path: "/masters/folders/add/:vessel_type_id/:vessel_sub_type_id",
          name: "AddFolder",
          component: () => import("./views/masters/folders/add.vue"),
        },
        {
          path: "/masters/folders/edit/:id",
          name: "EditFolder",
          component: () => import("./views/masters/folders/edit.vue"),
        },
        {
          path: "/masters/folders/subfolders/list/:id",
          name: "ListSubFolder",
          component: () => import("./views/masters/folders/subfolder-list.vue"),
        },
        {
          path: "/masters/folders/:folder_id/subfolders/edit/:sub_folder_id",
          name: "EditSubFolder",
          component: () => import("./views/masters/folders/subfolder-edit.vue"),
        },
        {
          path: "/masters/folders/:folder_id/subfolders/add",
          name: "AddSubFolder",
          component: () => import("./views/masters/folders/subfolder-add.vue"),
        },
        {
          path: "/masters/power-bi",
          name: "PowerBI",
          component: () => import("./views/masters/power-bi/list.vue"),
        },
        {
          path: "/vessels",
          name: "Vessels",
          component: () => import("./views/vessel-management/listing.vue"),
        },
        {
          path: "/vessel/view/:id",
          name: "ViewVessel",
          component: () => import("./views/vessel-management/view-vessel.vue"),
        },
        {
          path: "/vessel/add",
          name: "AddVessel",
          component: () => import("./views/vessel-management/add-vessel.vue"),
        },
        {
          path: "/vessel/edit/:id",
          name: "EditVessel",
          component: () => import("./views/vessel-management/edit-vessel.vue"),
        },
        {
          path: "/questions",
          name: "Questions",
          component: () => import("./views/questionnaire/listing.vue"),
        },
        {
          path: "/question/add",
          name: "QuestionAdd",
          component: () => import("./views/questionnaire/add-question.vue"),
        },
        {
          path: "/question/edit/:id",
          name: "QuestionEdit",
          component: () => import("./views/questionnaire/edit-question.vue"),
        },
        {
          path: "/question/view/:id",
          name: "QuestionView",
          component: () => import("./views/questionnaire/view-question.vue"),
        },
        {
          path: "/risk-management/hazards",
          name: "Hazards",
          component: () => import("./views/risk-management/hazards/list.vue"),
        },
        {
          path: "/risk-management/hazard/add",
          name: "AddHazard",
          component: () => import("./views/risk-management/hazards/add.vue"),
        },
        {
          path: "/risk-management/hazard/edit/:id",
          name: "EditHazard",
          component: () => import("./views/risk-management/hazards/edit.vue"),
        },
        {
          path: "/risk-management/top-events",
          name: "Topevents",
          component: () =>
            import("./views/risk-management/top-events/list.vue"),
        },
        {
          path: "/risk-management/top-event/add",
          name: "AddTopevent",
          component: () => import("./views/risk-management/top-events/add.vue"),
        },
        {
          path: "/risk-management/top-event/edit/:id",
          name: "EditTopevent",
          component: () =>
            import("./views/risk-management/top-events/edit.vue"),
        },
        {
          path: "/risk-management/preventative-barriers",
          name: "Preventativebarriers",
          component: () =>
            import("./views/risk-management/preventative-barriers/list.vue"),
        },
        {
          path: "/risk-management/preventative-barrier/add",
          name: "AddPreventativebarrier",
          component: () =>
            import("./views/risk-management/preventative-barriers/add.vue"),
        },
        {
          path: "/risk-management/preventative-barrier/edit/:id",
          name: "EditPreventativebarrier",
          component: () =>
            import("./views/risk-management/preventative-barriers/edit.vue"),
        },
        {
          path: "/risk-management/threats",
          name: "Threats",
          component: () => import("./views/risk-management/threats/list.vue"),
        },
        {
          path: "/risk-management/threat/add",
          name: "AddThreat",
          component: () => import("./views/risk-management/threats/add.vue"),
        },
        {
          path: "/risk-management/threat/edit/:id",
          name: "EditThreat",
          component: () => import("./views/risk-management/threats/edit.vue"),
        },
        {
          path: "/risk-management/mitigating-barriers",
          name: "Mitigatingbarriers",
          component: () =>
            import("./views/risk-management/mitigating-barriers/list.vue"),
        },
        {
          path: "/risk-management/mitigating-barrier/add",
          name: "AddMitigatingbarrier",
          component: () =>
            import("./views/risk-management/mitigating-barriers/add.vue"),
        },
        {
          path: "/risk-management/mitigating-barrier/edit/:id",
          name: "EditMitigatingbarrier",
          component: () =>
            import("./views/risk-management/mitigating-barriers/edit.vue"),
        },

        {
          path: "/risk-management/consequences",
          name: "Consequences",
          component: () =>
            import("./views/risk-management/consequences/list.vue"),
        },
        {
          path: "/risk-management/consequence/add",
          name: "AddConsequence",
          component: () =>
            import("./views/risk-management/consequences/add.vue"),
        },
        {
          path: "/risk-management/consequence/edit/:id",
          name: "EditConsequence",
          component: () =>
            import("./views/risk-management/consequences/edit.vue"),
        },

        {
          path: "/risk-management/escalation-factors",
          name: "Escalationfactors",
          component: () =>
            import("./views/risk-management/escalation-factors/list.vue"),
        },
        {
          path: "/risk-management/escalation-factor/add",
          name: "AddEscalationfactor",
          component: () =>
            import("./views/risk-management/escalation-factors/add.vue"),
        },
        {
          path: "/risk-management/escalation-factor/edit/:id",
          name: "EditEscalationfactor",
          component: () =>
            import("./views/risk-management/escalation-factors/edit.vue"),
        },

        {
          path: "/risk-management/escalation-factor-barriers",
          name: "EscalationfactorBarriers",
          component: () =>
            import(
              "./views/risk-management/escalation-factor-barriers/list.vue"
            ),
        },
        {
          path: "/risk-management/escalation-factor-barrier/add",
          name: "AddEscalationfactorBarrier",
          component: () =>
            import(
              "./views/risk-management/escalation-factor-barriers/add.vue"
            ),
        },
        {
          path: "/risk-management/escalation-factor-barriers/edit/:id",
          name: "EditEscalationfactorBarrier",
          component: () =>
            import(
              "./views/risk-management/escalation-factor-barriers/edit.vue"
            ),
        },
        // activities - ONLY_FOR_REFERENCE
        {
          path: "/activities",
          name: "Activities",
          component: () => import("./views/activities/list.vue"),
        },
        {
          path: "/:model/history/:id",
          name: "History",
          component: () => import("./layouts/components/activities/list.vue"),
          props: true,
        },

        // Projects
        {
          path: "/projects",
          name: "Projects",
          component: () => import("./views/projects/listing.vue"),
        },
        {
          path: "/project/add",
          name: "AddProject",
          component: () => import("./views/projects/add-project.vue"),
        },
        {
          path: "/project/edit/:id",
          name: "EditProject",
          component: () => import("./views/projects/edit-project.vue"),
        },
        {
          path: "/project/view/:id",
          name: "ViewProject",
          component: () => import("./views/projects/view-project.vue"),
        },
        {
          path: "/project/question/:id",
          name: "Question",
          component: () => import("./views/projects/question.vue"),
        },
        {
          path: "/project/inspection/:id",
          name: "Inspection",
          component: () => import("./views/projects/inspection.vue"),
        },
        {
          path: "/project/inspection-old/:id",
          name: "Inspection-old",
          component: () => import("./views/projects/inspection-old.vue"),
        },
        {
          path: "/project/review/:id",
          name: "Review",
          component: () => import("./views/projects/review.vue"),
        },
        {
          path: "/project/list-review-report/:project_id",
          name: "ReviewReport",
          component: () => import("./views/projects/list-review-report.vue"),
        },
        {
          path: "/demo",
          name: "Demo",
          component: () => import("./views/demo.vue"),
        },
        {
          path: "/upload-multiple-demo",
          component: () => import("./views/upload-multiple-demo.vue"),
        },
        {
          path: "/documents/add/:id?",
          name: "AddDocument",
          component: () => import("./views/documents/add.vue"),
        },
        {
          path: "/documents/edit/:id/:user_id?",
          name: "EditDocument",
          component: () => import("./views/documents/edit.vue"),
        },

        // Compare
        {
          path: "/compare",
          name: "Compare",
          component: () => import("./layouts/components/compare/compare.vue"),
        },

        {
          path: "/ai-report-analyst",
          name: "AiAnalyst",
          component: () => import("./views/ai/report.vue"),
        },
      ],
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: "",
      component: () => import("@/layouts/full-page/FullPage.vue"),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: "/login",
          name: "login",
          component: () => import("./views/login/login.vue"),
        },

        {
          path: "/error-404",
          name: "page-error-404",
          component: () => import("@/views/error404.vue"),
        },
        {
          path: "/explore",
          name: "explore-sid",
          component: () => import("@/views/explore/explore.vue"),
        },

        {
          path: "/forgot-password",
          name: "ForgotPassword",
          component: () => import("./views/login/forgot-password.vue"),
        },

        {
          path: "/reset-password",
          name: "ResetPassword",
          component: () => import("./views/login/reset-password.vue"),
        },
      ],
    },
    // Redirect to 404 page, if no match found
    {
      path: "*",
      redirect: "/error-404",
    },
  ],
});

const checkToken = () => {
  if (localStorage.getItem("authToken") && localStorage.getItem("user")) {
    return true;
  } else {
    return false;
  }
};

router.beforeEach((to, from, next) => {
  if (
    to.name !== "login" &&
    to.name !== "ForgotPassword" &&
    to.name !== "ResetPassword" &&
    to.name !== "explore-sid"
  ) {
    if (checkToken()) {
      const userData = JSON.parse(localStorage.getItem("user"));
      const title = userData.type_name
        ? `${userData.type_name} - SalusTech Integrated Database`
        : "SalusTech Integrated Database";
      document.title = title;
      if (
        store.state.userInfo.type !== "A" &&
        store.state.userInfo.type !== "CL"
      ) {
        if (to.name === "Dashboard") {
          router.push("/vessels");
          next();
        }
      } else {
        next();
      }
    } else {
      //next()
      next({
        name: "login",
      });
    }
  }
  next();
});
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

export default router;
